// Quiz Core - Essential functionality that loads immediately
(function() {
  'use strict';
  
  // Global quiz state
  window.quizState = {
    formData: {},
    stepList: [],
    currentStepIndex: 0,
    totalSteps: 0,
    isInitialized: false,
    conditionalLogicData: [],
    productRecommendationsData: []
  };

  // Essential functions that need to work immediately
  function initializeQuizCore() {
    // Get all quiz steps
    var allSteps = document.querySelectorAll('.quiz-step[data-step]');
    allSteps.forEach(function(step) {
      var stepNumber = step.getAttribute('data-step');
      var parsedStep = parseFloat(stepNumber);
      window.quizState.stepList.push(isNaN(parsedStep) ? stepNumber : parsedStep);
    });

    var stepOrder = ['user_info', 'recommendations'];
    window.quizState.stepList.sort(function(a, b) {
      if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
      } else if (typeof a === 'number') {
        return -1;
      } else if (typeof b === 'number') {
        return 1;
      } else {
        var indexA = stepOrder.indexOf(a);
        var indexB = stepOrder.indexOf(b);
        return indexA - indexB;
      }
    });

    window.quizState.totalSteps = window.quizState.stepList.length;
    
    // Update progress display
    var totalStepsElement = document.getElementById('total-steps-number');
    if (totalStepsElement) {
      totalStepsElement.innerText = window.quizState.totalSteps;
    }

    // Show first step immediately
    showStepByIndex(0);
    
    // Enable next buttons immediately
    enableNextButtons();
    
    // Update Start Quiz button to ready state
    var startButton = document.getElementById('start-quiz-btn');
    if (startButton) {
      startButton.disabled = false;
      startButton.classList.remove('quiz-btn-loading');
      startButton.classList.add('quiz-btn-ready');
      var btnText = startButton.querySelector('.btn-text');
      if (btnText) {
        btnText.textContent = startButton.getAttribute('data-ready-text') || 'Start Quiz';
      }
    }
    
    window.quizState.isInitialized = true;
  }

  function showStepByIndex(index) {
    if (index < 0 || index >= window.quizState.stepList.length) {
      return;
    }

    var stepIdentifier = window.quizState.stepList[index];
    var stepElement = document.querySelector('.quiz-step[data-step="' + stepIdentifier + '"]');
    if (stepElement) {
      stepElement.style.display = 'grid';
      window.quizState.currentStepIndex = index;
      updateProgress();
      
      var nextButton = stepElement.querySelector('.next-button');
      var inputs = stepElement.querySelectorAll('input');

      if (nextButton) {
        if (inputs.length === 0) {
          nextButton.disabled = false;
        } else {
          nextButton.disabled = true;
          checkValidInput(stepElement, nextButton, inputs);
        }
      }
    }
  }

  function checkValidInput(stepElement, nextButton, inputs) {
    function validateInputs() {
      var validInput = false;
      inputs.forEach(function(input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (input.checked) {
            validInput = true;
          }
        } else if (input.type === 'text' || input.type === 'email') {
          if (input.value.trim() !== '') {
            validInput = true;
          }
        }
      });
      nextButton.disabled = !validInput;
    }

    validateInputs();
    inputs.forEach(function(input) {
      input.addEventListener('input', validateInputs);
    });
  }

  function updateProgress() {
    var progressElement = document.getElementById('current-step-number');
    var totalStepsElement = document.getElementById('total-steps-number');
  
    var visibleSteps = window.quizState.stepList.filter(function(step) {
      return typeof step === 'number';
    }).length;
  
    var currentVisibleStep = window.quizState.stepList.slice(0, window.quizState.currentStepIndex + 1).filter(function(step) {
      return typeof step === 'number';
    }).length;
  
    if (progressElement) {
      progressElement.innerText = currentVisibleStep;
    }
  
    if (totalStepsElement) {
      totalStepsElement.innerText = visibleSteps;
    }
  }

  function enableNextButtons() {
    var nextButtons = document.querySelectorAll('button.next-button, a.next-button');
    nextButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        if (button.tagName.toLowerCase() === 'a') {
          event.preventDefault();
        }

        var stepElement = this.closest('.quiz-step');
        var stepIdentifier = stepElement.getAttribute('data-step');
        var stepIndex = window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) >= 0 ? 
          window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) : 
          window.quizState.stepList.indexOf(stepIdentifier);

        // Save user input
        var inputs = stepElement.querySelectorAll('input');
        inputs.forEach(function(input) {
          if (input.type === 'radio' && input.checked) {
            window.quizState.formData['step_' + stepIdentifier] = input.value;
          } else if (input.type === 'checkbox' && input.checked) {
            if (!window.quizState.formData['step_' + stepIdentifier]) {
              window.quizState.formData['step_' + stepIdentifier] = [];
            }
            window.quizState.formData['step_' + stepIdentifier].push(input.value);
          } else if (input.type === 'text' || input.type === 'email') {
            window.quizState.formData[input.name] = input.value.trim();
          }
        });

        // Hide current step
        hideStepByIndex(stepIndex);

        // Show next step
        goToNextStep();
      });
    });

    var backButtons = document.querySelectorAll('.back-button');
    backButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var stepElement = this.closest('.quiz-step');
        var stepIdentifier = stepElement.getAttribute('data-step');
        var stepIndex = window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) >= 0 ? 
          window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) : 
          window.quizState.stepList.indexOf(stepIdentifier);

        hideStepByIndex(stepIndex);
        goToPreviousStep();
      });
    });
  }

  function hideStepByIndex(index) {
    if (index < 0 || index >= window.quizState.stepList.length) return;
    var stepIdentifier = window.quizState.stepList[index];
    var stepElement = document.querySelector('.quiz-step[data-step="' + stepIdentifier + '"]');
    if (stepElement) {
      stepElement.style.display = 'none';
    }
  }

  function goToNextStep() {
    var nextIndex = window.quizState.currentStepIndex + 1;
    while (nextIndex < window.quizState.stepList.length) {
      var nextStep = window.quizState.stepList[nextIndex];
      
      // For now, show all steps (conditional logic will be handled by full quiz.js)
      hideStepByIndex(window.quizState.currentStepIndex);
      showStepByIndex(nextIndex);
      return;
    }
    
    // If we reach here, show results
    displayResults();
  }

  function goToPreviousStep() {
    var prevIndex = window.quizState.currentStepIndex - 1;
    while (prevIndex >= 0) {
      var prevStep = window.quizState.stepList[prevIndex];
      hideStepByIndex(window.quizState.currentStepIndex);
      showStepByIndex(prevIndex);
      return;
    }
  }

  function displayResults() {
    var results = document.createElement('div');
    results.id = 'quiz-results';
    results.innerHTML = '<h2>Thank you for completing the quiz!</h2><pre>' + JSON.stringify(window.quizState.formData, null, 2) + '</pre>';
    document.getElementById('quiz-form').appendChild(results);
  }

  // Initialize immediately when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuizCore);
  } else {
    initializeQuizCore();
  }

  // Expose essential functions globally for the full quiz.js to use
  window.quizCore = {
    showStepByIndex: showStepByIndex,
    hideStepByIndex: hideStepByIndex,
    goToNextStep: goToNextStep,
    goToPreviousStep: goToPreviousStep,
    updateProgress: updateProgress
  };

})();
